import type { EntityType } from '../types/EntityType';

const GROUPS_SYSTEM_ENTITY_TYPE_NAME = 'Groups';

/**
 * Identifies the seeded system entity type that backs the legacy Groups pages.
 * Both `is_system` and the name are required: a client can create a custom type
 * called "Groups", and that one is a browse-like-any-other entity type.
 */
export const isGroupsSystemEntityType = (entityType: EntityType) =>
  entityType.is_system && entityType.name === GROUPS_SYSTEM_ENTITY_TYPE_NAME;
